import { IProps } from '@components/messages/types';
import React, { createContext, FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/epics/userPrefEpics';
import { LegacyActions } from '../redux/actions';
import { IProductFamily } from '../types';


export interface ILegacyFamilyContext {
  items: IProductFamily[];
  setItems: (item: any) => void;
  loading: boolean;
  getItems: () => void;
}

export const LegacyFamilyContext = createContext<ILegacyFamilyContext>(
  {} as ILegacyFamilyContext
);

const LegacyFamilyProvider: FC<IProps> = ({ children }) => {
  const dispatch = useDispatch();
  const itemsSelector = useSelector(
    (state: RootState) => state.legacyFamily.items
  );
  const isProgress = useSelector(
    (state: RootState) => state.legacyFamily.isProgress
  );
  const [items, setItems] = useState<IProductFamily[]>([]);

  useEffect(() => {
    if (itemsSelector.data.length) {
      setItems(itemsSelector.data);
    }
  }, [itemsSelector]);
  // context

  const getItems = () => {
    dispatch(LegacyActions.listLegacy({}));
    LegacyActions.getLegacy()
      .then((res) => {
        dispatch(LegacyActions.listLegacySuccess(res.data));
      })
      .catch((err) => {
        dispatch(LegacyActions.listLegacyFail(err));
      });
    return [];
  };

  const value = useMemo(
    () => ({
      items,
      setItems,
      loading: isProgress,
      getItems,
    }), // eslint-disable-next-line
    [items, isProgress]
  );

  return (
    <LegacyFamilyContext.Provider value={value}>
      {children}
    </LegacyFamilyContext.Provider>
  );
};

export default LegacyFamilyProvider;
